var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navbar',{staticStyle:{"position":"sticky","top":"0","z-index":"10"}}),_c('router-view'),_c('Footer',{staticStyle:{"z-index":"10"}}),_c('backtop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }